import colors from "theme/colors";

const styles = {
  menu: {
    width: "360px",
    padding: "12px",
    backgroundColor: colors.neutral.cotton,
    borderRadius: "12px",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.18)",
    marginTop: "8px",
  },
  header: {
    fontSize: "20px",
    fontWeight: "700",
    color: colors.neutral.charcoal,
  },
  sectionLabel: {
    fontSize: "12px",
    color: colors.neutral.darkMist,
  },
  itemTitle: {
    fontWeight: "600",
    color: colors.neutral.charcoal,
  },
  itemDescription: {
    color: colors.neutral.charcoal,
  },
  timeText: {
    fontSize: "11px",
    color: colors.neutral.darkMist,
  },
  highlightItem: {
    backgroundColor: colors.secondary.daybreakLight,
    borderRadius: "8px",
    padding: "10px",
  },
  itemContainer: {
    borderRadius: "8px",
    padding: "10px",
  },
  itemHover: {
    backgroundColor: colors.secondary.daybreakLight,
  },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "999px",
    backgroundColor: colors.error.rose,
    marginTop: "6px",
  },
  dotHidden: {
    width: "8px",
    height: "8px",
    borderRadius: "999px",
    backgroundColor: "transparent",
    marginTop: "6px",
  },
  footerButton: {
    color: colors.secondary.orchid,
    fontWeight: "600",
  },
  footerButtonDisabled: {
    color: colors.disabled.smoke,
    fontWeight: "600",
  },
};

export default styles;
